import type { Day } from "../types";
import { getCurrentDate } from "./formatTime";

/**
 * Returns the closest or active day ID based on festival hours (2 PM to 6 AM next day)
 */
export function getClosestDayId(days: Day[]): string {
  if (days.length === 0) return "";

  const now = getCurrentDate();
  const currentHour = now.getHours();

  // If it's before 2 PM, we're still in the previous festival day (which ended at 6 AM)
  const currentDate = new Date(now);
  if (currentHour < 14) {
    // Subtract one day to get the previous festival day
    currentDate.setDate(currentDate.getDate() - 1);
  }

  // Format as YYYY-MM-DD to match the day.date format
  const currentDateStr = currentDate.toISOString().split("T")[0];

  // Find the day that matches the calculated date
  const activeDay = days.find((day) => day.date === currentDateStr);

  // If no matching day found (shouldn't happen with valid data), fall back to closest day
  if (!activeDay) {
    return days.reduce((closest, day) => {
      const dayDate = new Date(day.date);
      return Math.abs(dayDate.getTime() - now.getTime()) <
        Math.abs(new Date(closest.date).getTime() - now.getTime())
        ? day
        : closest;
    }).id;
  }

  return activeDay.id;
}
